const HAPTIC_MESSAGE = "EASYFIT_HAPTIC";

/**
 * Dispara feedback háptico (vibração) quando disponível.
 * - Em WebView nativo (iOS/Android via Expo): envia mensagem para o app nativo
 *   executar a vibração via expo-haptics (funciona no iOS onde navigator.vibrate não existe).
 * - Em Android browser: usa a Web Vibration API como fallback.
 * @param duration Duração em ms para o fallback Web (padrão 15)
 */
export function vibrateTactile(duration = 15): void {
  // WebView nativo: delega para o app via postMessage
  if (
    typeof window !== "undefined" &&
    (window as unknown as { ReactNativeWebView?: { postMessage: (msg: string) => void } })
      .ReactNativeWebView
  ) {
    try {
      (window as unknown as { ReactNativeWebView: { postMessage: (msg: string) => void } })
        .ReactNativeWebView.postMessage(HAPTIC_MESSAGE);
    } catch {
      // silencioso
    }
    return;
  }

  // Fallback: Web Vibration API (Android Chrome, alguns browsers)
  if (
    typeof navigator !== "undefined" &&
    typeof navigator.vibrate === "function"
  ) {
    try {
      navigator.vibrate(duration);
    } catch {
      // API não suportada ou bloqueada
    }
  }
}
